var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"label":"Name","closeOnSelect":true,"taggable":"","options":_vm.users,"dir":_vm.$vs.rtl ? 'rtl' : 'ltr'},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }